<div class="wrapper animated fadeIn">
    <!-- start .row -->
    <div class="row animated fadeIn">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg-administracion.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->

        <app-info-user [home]="false" [configuracion]="false"></app-info-user>

        <!--/ end row -->
        <div class="row">
            <div class="col-md-6 col-lg-4">

                <div class="card m-b-30 puntero">
                    <div class="card-body">
                        <h5 class="card-title">Usuarios</h5>
                        <h6 class="card-subtitle text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy </h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/administracion1.jpg" alt="Radicación">

                </div>

            </div>
            <!-- end col -->



            <div class="col-md-6 col-lg-4">

                <div class="card m-b-30 puntero">
                    <div class="card-body">
                        <h5 class="card-title">Auditorías</h5>
                        <h6 class="card-subtitle text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy </h6>
                    </div>
                    <img class="card-img-top img-fluid" src="./assets/global/images/small/administracion2.jpg" alt="Incumplimiento">

                </div>

            </div>
            <!-- end col -->


            <div class="col-md-6 col-lg-4">

                <div class="card m-b-30 puntero">
                    <div class="card-body">
                        <h5 class="card-title">Paramétricas</h5>
                        <h6 class="card-subtitle text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy </h6>
                    </div>
                    <img class="img-fluid" src="./assets/global/images/small/administracion3.jpg" alt="Reportes">

                </div>

            </div>
            <!-- end col -->



        </div>
        <!-- end row -->
        <div class="blanco"></div>

    </div>
    <!-- end container -->
</div>
<!-- end wrapper -->